export default __webpack_public_path__ + "static/media/10.714d0a26.png";